import { Reveal, MaskLines } from "./Reveal";
import LegalModals from "./LegalModals";
import { Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="about"
      data-testid="footer-section"
      className="relative overflow-hidden border-t border-hairline bg-ink"
    >
      <div className="pointer-events-none absolute -bottom-40 left-1/2 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-steel/15 blur-[150px]" />

      <div className="relative mx-auto max-w-[1400px] px-6 pb-12 pt-24 lg:px-12 lg:pt-32">
        <div className="grid grid-cols-1 gap-12 border-b border-hairline pb-16 md:grid-cols-2">
          <Reveal>
            <p className="mb-4 flex items-center gap-4 font-body text-xs font-semibold uppercase tracking-[0.3em] text-steel-light">
              <span className="h-px w-10 bg-steel-light/60" /> General enquiries
            </p>
            <a
              href="mailto:info@alyakhour.com"
              data-testid="footer-email-link"
              className="group inline-flex items-center gap-4 font-display text-3xl font-bold tracking-tight text-cloud transition-colors duration-300 hover:text-steel-light sm:text-4xl"
            >
              <Mail className="hidden sm:block" size={34} strokeWidth={1.5} />
              info@alyakhour.com
            </a>
          </Reveal>

          <Reveal delay={0.1} className="font-body text-sm leading-relaxed text-fog" data-testid="company-details">
            <p className="mb-5 font-body text-xs font-semibold uppercase tracking-[0.3em] text-steel-light">
              Company details
            </p>
            <dl className="space-y-3">
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Company name</dt>
                <dd className="text-cloud">Al Yakhour LLC</dd>
              </div>
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Registered agent</dt>
                <dd className="text-cloud">Registered Agents Inc</dd>
              </div>
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Registered address</dt>
                <dd className="text-cloud">30 N Gould St Ste R, Sheridan, WY 82801</dd>
              </div>
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Mailing address</dt>
                <dd className="text-cloud">30 N Gould St, STE 20119, Sheridan, WY 82801</dd>
              </div>
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Principal office address</dt>
                <dd className="text-cloud">30 N Gould St, STE 20119, Sheridan, WY 82801</dd>
              </div>
              <div>
                <dt className="text-[11px] uppercase tracking-[0.2em] text-fog/60">Sister entity</dt>
                <dd className="text-cloud">
                  Al Yakhour Dış Ticaret — Istanbul, Turkey
                  <span className="mt-1 block text-xs font-normal text-fog/60">
                    A sister entity under the Al Yakhour Group.
                  </span>
                </dd>
              </div>
            </dl>
          </Reveal>
        </div>

        <div className="mt-24 overflow-hidden">
          <MaskLines
            className="font-display text-[15vw] font-extrabold leading-[0.85] tracking-tighter text-cloud/90 sm:text-[13vw]"
            lines={["AL YAKHOUR LLC"]}
          />
        </div>

        <div className="mt-16 flex flex-col gap-6 border-t border-hairline pt-8 lg:flex-row lg:items-center lg:justify-between">
          <p className="font-body text-sm text-fog" data-testid="footer-copyright">
            © 2026 Al Yakhour LLC. All rights reserved.
          </p>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:gap-8">
            <LegalModals />
            <p className="font-body text-xs uppercase tracking-[0.25em] text-fog/70">
              Technology · Media · Hospitality
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
